<div class="root">
  <router-outlet></router-outlet>
</div>
